export default {
  name: 'calendar',
  translationKey: 'calendar-module',
  routePrefix: 'calendar',
  routeNamePrefix: 'calendar',
  directRoutesAvailable: true,
}
